module.exports = "/_next/static/images/86c03073bb121aee34ab983dd74b80fe-card-hugh.svg.webp";